import { authorSearchConstants } from '../constants';

const initialState = {
    authorName:'',
    authorKey:[],
    allAuthors:[],
    allSource:[],
    alldocs:'',
    eDate:'',
    sDate:'',
    timeStatus:'',
    searchType:'全域搜尋',
}

export function authorSearch(state = initialState, action) {
  switch (action.type) {
    case authorSearchConstants.GET_DAY:
      return{
        ...state,
        sDate:action.sDate,
        eDate:action.eDate,
      }
    case authorSearchConstants.SET_TIME_STATUS:
      return{
        ...state,
        timeStatus:action.timeStatus ? action.timeStatus : state.timeStatus,
      }
    case authorSearchConstants.A_NAME:
      return{
        ...state,
        authorName:action.authorName,
      }
      case authorSearchConstants.REQUEST_AUTHOR:
        return { ...state };
      case authorSearchConstants.RECEIVE_AUTHOR:
        return {
          ...state,
          searchData: action.searchData,
          allSource: action.allSource ? action.allSource : state.allSource,
          allAuthors: action.allAuthors ? action.allAuthors : state.allAuthors,
          sDate: action.sdate,
          eDate: action.edate,
        };
      case authorSearchConstants.SET_DOCS:
        return{
          ...state,
          alldocs:action.alldocs,
        }
      case authorSearchConstants.SWITCH_TYPE:
        return {
          ...state,
          searchType:action.searchType ? action.searchType : state.searchType,
        }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authorSearch.reducer.js